/**
 * The frame around every /app screen: sidebar on the left, the current
 * section on the right (the router's Outlet), SEO links at the bottom.
 */

import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { SeoFooterLinks } from "../SeoFooterLinks";

export function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 text-slate-900 antialiased">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col overflow-hidden bg-white">
        <div className="flex min-h-0 flex-1 flex-col">
          <Outlet />
        </div>
        <SeoFooterLinks />
      </main>
    </div>
  );
}
